export function slugifyReleaseName(name: string): string {
  return name
    .toLowerCase()
    .normalize("NFD") // handle accented characters
    .replace(/[\u0300-\u036f]/g, "") // remove accents
    .replace(/[^a-z0-9\s-]/g, "") // remove symbols except space and dash
    .trim()
    .replace(/\s+/g, "-") // replace spaces with dashes
    .replace(/-+/g, "-") || "music"; // Keep symbol-only titles addressable.
}
